import script from "./space-around-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./space-around-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./space-around-setting-ly.vue?vue&type=style&index=0&id=522ecafc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-522ecafc"]])

export default __exports__